import api from '../../api'

const recurrenceAPI = api.create('recurrence', false)

const login = data => {
  return recurrenceAPI.post('/auth_user.json', data)
}

const loginCustomer = data => {
  return recurrenceAPI.post('/auth_customer.json', data)
}

const resetPassword = email => {
  return recurrenceAPI.get('/users/recover_password?email=' + email)
}

const redefinePassword = data => {
  return recurrenceAPI.patch('/users/reset_password', data)
}

export default {
  login,
  loginCustomer,
  redefinePassword,
  resetPassword,
}
